<table class="simple mt-8">
    <thead>
        <tr>
            <th>OOTT</th>
            <th>Estado</th>
            <th>Fecha</th>
            <th>Valor UF</th>
            <th>Ticket</th>
            <th>PDF</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let ot of ordenesTrabajo">
            <td>
                <a [routerLink]="'/ordenes-de-trabajo/' + ot.idOrdenTrabajo">
                    {{ ot.idOrdenTrabajo }}
                </a>
            </td>
            <td>{{ ot.estado.descripcion }}</td>
            <td>{{ ot.fecha | date: "dd-MM-YYYY" }}</td>
            <td>{{ ot.valorUf }}</td>
            <td>{{ ot.ticket }}</td>
            <td>
                <button
                    *ngIf="ot.estado.id === config.oott.estados.recepcionada.id"
                    mat-icon-button
                    type="button"
                    color="accent"
                    (click)="bajarPdf(ot.idOrdenTrabajo)"
                >
                    <mat-icon>cloud_download</mat-icon> Descargar
                </button>
                <span
                    *ngIf="ot.estado.id !== config.oott.estados.recepcionada.id"
                    ><small
                        >Disponible solo en estado
                        <strong>recepcionada</strong></small
                    ></span
                >
            </td>
        </tr>
    </tbody>
</table>
